<template>
  <div class="dbs_pr-container">
    <loading-indicator :isLoading="isProcessing" loadingText="Dziękujemy! Zapisujemy Twoją opinię!"
                       loadingStyle="padding: 20px 5px">
      <h2 class="t-head t-head--primary u-text-center">Oceń produkt</h2>

      <form action="#" method="">
        <div class="c-product-teaser">
          <figure class="c-product-teaser__pic">
            <img :src="product.picture" alt="">
          </figure>
          <div class="c-product-teaser__main">
            <h3 class="t-head t-head--review u-paint-green">{{ productName }}</h3>
          </div>
        </div>
        <c-stars-input v-if="showRatingInput" @rating-changed="ratingChanged" size="xl" :centered="true" :start-rating="review.rating"
                       :readonly="false" />
        <p class="f-message is-error" v-if="errors.rating">{{ errors.rating }}</p>
        <p class="f-message is-error" v-if="errors.global">{{ errors.global }}</p>

        <div class="f-field" v-if="ratingSet">
          <textarea cols="2" rows="2" placeholder="Co sądzisz o tym produkcie? Twoja opinia pomoze innym!"
                    class="f-control f-control--default f-control--textarea f-control--sh-1"
                    v-model="review.body"></textarea>
          <p class="f-message is-error" v-if="errors.body">{{ errors.body }}</p>
        </div>
        <p class="f-message is-error" v-if="errors.auth">{{ errors.auth }}</p>
        <div v-if="recaptchaRequired">
          <vue-recaptcha sitekey="6LcozuQZAAAAANA6ibB05zG3m9UabZQVukX1I3vC"
            :loadRecaptchaScript="true"
            type="checkbox"
            language="pl"
            @verify="onCaptchaVerify"></vue-recaptcha>
        </div>
        <ul class="c-actions-list u-justify-content-center" v-if="ratingSet">
          <li class="c-actions-list__item">
            <button type="submit" class="c-btn c-btn--default c-btn--theme-6 c-btn--border-radius-full" @click.prevent="sendReview">
              {{saveButtonMessage}}
            </button>
          </li>
        </ul>
      </form>
    </loading-indicator>
  </div>
</template>

<script>
import {addProductReview, getPreviousReview} from '@/api/productReviews'
import PermanentStorage from '@/services/permanentStorage'
import Rating from '@/components/Rating'
import RatingInput from '@/components/RatingInput'
import LoadingIndicator from '@/components/LoadingIndicator'
import CStarsInput from '@/components/CStarsInput'
import {EventBus, GlobalEvents} from '@/shared'
import CStars from '@/components/CStars'
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {
    CStars,
    LoadingIndicator,
    Rating,
    RatingInput,
    CStarsInput,
    VueRecaptcha
  },

  props: ['product', 'averageRating', 'reviewsCount', 'initialRating'],

  data () {
    return {
      review: {
        rating: 0,
        body: ''
      },
      errors: [],
      isProcessing: false,
      ratingSet: false,
      recaptchaRequired: false,
      recaptchaCode: '',
      saveButtonMessage: 'Dodaj opinię',
      showRatingInput: false
    }
  },

  mounted () {
    if (this.initialRating) {
      this.review.rating = this.initialRating
      this.ratingSet = true
      this.showRatingInput = true
    } else {
      getPreviousReview(this.product.id)
        .then(previousReview => {
          if (previousReview) {
            this.review.rating = previousReview.rating
            this.review.body = previousReview.body
            this.ratingSet = true
            this.saveButtonMessage = 'Zapisz opinię'
          }
        }).finally(() => {
          this.showRatingInput = true
        })
    }
  },

  computed: {
    productName () {
      if (this.product.manufacturer) {
        return `${this.product.manufacturer} - ${this.product.name}`
      }

      return `${this.product.name}`
    }
  },

  methods: {
    ratingChanged ({rating}) {
      this.review.rating = rating
      this.ratingSet = true

      // this.sendRating()
    },

    sendRating () {
      const self = this
      addProductReview({...this.review, productId: this.product.id})
        .then(result => {
          if (result.reviewId) {
            PermanentStorage.setValue(this._reviewIdCacheKey(), result.reviewId)
          }
        })
        .catch(() => {
          self.setGlobalError('Nie udało się dodać oceny. Spróbuj ponownie.')
        })
    },

    sendReview () {
      if (this.validate()) {
        const self = this
        self.setIsProcessing(true)
        const cachedReviewId = PermanentStorage.getValue(this._reviewIdCacheKey())
        addProductReview({...this.review, reviewId: cachedReviewId, productId: this.product.id}, this.recaptchaRequired ? this.recaptchaCode : false)
          .then(result => {
            self.setIsProcessing(false)
            if (result.error) {
              self.setAuthError(this.processError(result.error))
            } else {
              self.$emit('review-added')
            }
          })
          .catch(() => {
            self.setIsProcessing(false)
            self.setGlobalError('Nie udało się dodać opinii. Spróbuj ponownie.')
          })
      }
    },
    processError (error) {
      const errorTranslation = {
        'Review has already been added for given product': 'Ten produkt był już przez ciebie oceniany.',
        'Please use captcha or log in': 'Zaloguj się aby dodać recenzję lub potwierdź, że nie jesteś robotem aby dodać ją anonimowo.'
      }

      if (error === 'Please use captcha or log in') {
        this.recaptchaRequired = true
      }

      return errorTranslation[error] ? errorTranslation[error] : 'Wystąpił nieznany błąd, spróbuj ponownie.'
    },
    onCaptchaVerify (response) {
      this.recaptchaCode = response
    },

    validate () {
      this.errors = {}

      this.validateRating()
      this.validateBody()

      return Object.keys(this.errors).length === 0
    },

    validateRating () {
      if (this.review.rating < 1 || this.review.rating > 5) {
        this.errors['rating'] = 'Ocena jest wymagana'
      }
    },

    validateBody () {
      if (!this.review.body) {
        this.errors['body'] = 'Komentarz jest wymagany'
      } else if (this.review.body.length < 2) {
        this.errors['body'] = 'Komentarz jest wymagany'
      }
    },

    setGlobalError (error) {
      this.errors = {global: error}
    },

    setAuthError (error) {
      this.errors = {auth: error}
    },

    setIsProcessing (isProcessing) {
      this.isProcessing = isProcessing
      EventBus.$emit(GlobalEvents.reviews_processingChanged, {isProcessing})
    },

    _reviewIdCacheKey () {
      return `review-id#${this.product.id}`
    }
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/AddProductReviewForm/AddProductReviewForm.vue